import { Scrollbars } from "react-custom-scrollbars-with-mac-support";
import { useTranslation } from "react-i18next";
const LanguageFilterDropdown = (props) => {
  const { t } = useTranslation("translation", { keyPrefix: "filters" });
  return (
    <div class="select-dropdown">
      <div className="filter-title">
        <h3 className="header-four">{t("languages_offered_title")}</h3>
        <button
          className="close-box"
          aria-label={t("close")}
          onClick={props.closeLangFilter}
        >
          <i class="btb bt-times"></i>
        </button>
      </div>

      <div className="filter-body">
        <Scrollbars
          style={props.getWindowWidth > 991.98 && { height: 120 }}
          renderTrackVertical={(props) => (
            <div {...props} className="track-vertical" />
          )}
          renderThumbVertical={(props) => (
            <div {...props} className="thumb-vertical" />
          )}
          className={`filter-options ${props.languagesList.length < 3 ? "hide-scrollBar":""}`}
        >
          <div className="form-check">
            <input
              type="checkbox"
              value="any"
              id="show_all_lang"
              onClick={props.getChangelanghanddler}
              checked={props.getLanguages.indexOf("any") != -1 ? "checked" : ""}
            />
            <label for="show_all_lang">{t("show_all")}</label>
          </div>
          {props.languagesList.length > 0 &&
            props.languagesList.map(
              (index) =>
                index.name.length > 0 && (
                  <div className="form-check">
                    <input
                      type="checkbox"
                      value={index.name}
                      id={index.name + "_" + index.count}
                      onClick={props.getChangelanghanddler}
                      checked={
                        props.getLanguages.indexOf(index.name) != -1
                          ? "checked"
                          : ""
                      }
                    />
                    <label for={index.name + "_" + index.count}>
                      {index.name} ({index.count})
                    </label>
                  </div>
                )
            )}
        </Scrollbars>
      </div>
      <div className="button-set">
        <button
          onClick={props.getpopulateDropdowns}
          className="button button__full-background button__full-background--bg-blue  button__full-background--color-white button__full-background--rounded button--font-family-helvetica-bold-rounded button__full-background--xs mr-sm-3 position-relative"
        >
          {t("show_results")}
        </button>
        <button
          className="button button__full-background button__full-background--rounded button--font-family-helvetica-bold-rounded  button__full-background--xs cancel-button"
          onClick={props.closeLangFilter}
        >
          {t("cancel")}
        </button>
      </div>
    </div>
  );
};

export default LanguageFilterDropdown;
